module.exports = __webpack_public_path__ + "files/6e1bb8e77744e18132f667ff9a57c22f.png";